export default {
    namespace: 'CorePeople',
    translations: {
        zh: {
            hero: {
                kicker: 'CORE PEOPLE',
                title: '核心人物',
                description: '顾问团队、行业专家、技术团队与运营团队协同构成未来世界的核心人物网络。'
            },
            advisorTitle: '顾问团队',
            industryTitle: '行业专家',
            technicalTitle: '技术团队',
            operationsTitle: '运营团队',
            technicalGroups: [
                {
                    title: '人工智能',
                    members: [
                        {
                            name: '胥 德文',
                            lines: ['深度学习专家', '东京大学教育研究科', '特任研究员', '拥有丰富的AI行业化经验', '推动深度学习与大数据', '在医疗、金融、制造业的落地']
                        },
                        {
                            name: '郭 志宇',
                            lines: ['奈良先端科学技术大学', '大语言模型方向博士', '专注于模型压缩', '长文本推理']
                        }
                    ]
                },
                {
                    title: '机器人',
                    members: [
                        {
                            name: 'Azhar Aulia Saputra',
                            lines: ['东京都立大学 博士后', '机器人设计专家/LLM专家', '10+篇高水平SCI', '30+篇论文']
                        },
                        {
                            name: '李 连超',
                            lines: ['东京都立大学', '智能机械方向硕士', '多年医疗产品', '精密机械/精密结构', '开发行业经验']
                        }
                    ]
                },
                {
                    title: '大数据',
                    members: [
                        {
                            name: '邬 扬捷',
                            lines: ['大数据行业专家', 'AI数据产品决策/管理', '拥有在日8年大数据实战经验', '50+日本中小企业', 'C-level 人脉']
                        },
                        {
                            name: '廖 威',
                            lines: ['大数据技术专家', '中科院自动化研究所 硕士', '数据科学部门副科长', 'Data*AI在商业应用和产品', '落地经验丰富']
                        }
                    ]
                }
            ],
            operationsGroups: [
                {
                    title: '税务法务',
                    members: [
                        {
                            name: '浅野 雅史',
                            lines: ['代表税理士', '从事中日税务法务20年', '出海投资咨询专家']
                        }
                    ]
                },
                {
                    title: '跨境对接',
                    members: [
                        {
                            name: '李 增达',
                            lines: ['日本ミライワールド', '株式会社CEO', '东京人工智能社区理事', '7年社区运营经验', '8年跨境项目对接经验']
                        }
                    ]
                },
                {
                    title: '本地渠道',
                    members: [
                        {
                            name: '李 时豪',
                            lines: ['创新和创业领域项目负责人', '前埃森哲战略顾问', '精通国际人才教育']
                        }
                    ]
                },
                {
                    title: '电商运营',
                    members: [
                        {
                            name: '边 汇翔',
                            lines: []
                        }
                    ]
                }
            ],
            featured: [
                {
                    name: '福田敏男',
                    title: '“世界微纳机器人之父”',
                    lines: [
                        '东京大学博士 日本名古屋大学教授',
                        '日本科学议院成员；日本工程院院士',
                        '2017年当选为中国科学院外籍院士',
                        'IEEE国际机器人与自动化学会先驱奖',
                        'IEEE国际机器人与自动化领域终身成就奖'
                    ]
                },
                {
                    name: '久保田直行',
                    title: '',
                    lines: [
                        '东京都立大学教授',
                        '名古屋大学工学博士',
                        '计算智能专家；智能机器人方面专家',
                        '多项相关专利',
                        '师从福田敏男教授'
                    ]
                },
                {
                    name: '许 春山',
                    title: '',
                    lines: [
                        '上海人工智能研究院首席发展官',
                        '江苏省科学技术进步一等奖'
                    ]
                }
            ],
            industryMembers: [
                {
                    name: '田中 理',
                    lines: ['QOLTON研究所理事长', '日本福祉用具评价中心理事长', '日本康复工程学创始人之一']
                },
                {
                    name: '五十嵐 幸夫',
                    lines: ['伊利诺伊理工学院', '建筑设计方向 硕士', '平均每年本地化管理', '70多个智能制造产品', 'java 技术支持和开发管理']
                },
                {
                    name: '真锅智幸',
                    lines: ['高级物流经理', '建立与营业、所长、货主', '共同出资的物流公司', '参与物流机器人引进项目', '大冢仓库负责人']
                },
                {
                    name: 'Yoshida Kaede',
                    lines: ['近30年日本IT相关企业管理及市场营销经验', '中欧EMBA日本分会会长', '在日本拥有广泛', '市场渠道资源']
                },
                {
                    name: '松本 有',
                    lines: ['日本工业设计协会理事', 'EU-Japan Design Competition审查员', '上海EXPO日本事务所委员']
                }
            ]
        },
        en: {
            hero: {
                kicker: 'CORE PEOPLE',
                title: 'Core People',
                description: 'Advisors, industry experts, technical specialists, and operations leaders together form Future World’s core people network.'
            },
            advisorTitle: 'Advisory Team',
            industryTitle: 'Industry Experts',
            technicalTitle: 'Technical Team',
            operationsTitle: 'Operations Team',
            technicalGroups: [
                {
                    title: 'Artificial Intelligence',
                    members: [
                        {
                            name: 'Xu Dewen',
                            lines: ['Deep learning expert', 'Project Researcher, Graduate School of Education, The University of Tokyo', 'Extensive experience in AI industrialization', 'Driving the implementation of deep learning and big data', 'Across healthcare, finance, and manufacturing']
                        },
                        {
                            name: 'Guo Zhiyu',
                            lines: ['PhD in large language models', 'Nara Institute of Science and Technology', 'Focused on model compression', 'Long-context reasoning']
                        }
                    ]
                },
                {
                    title: 'Robotics',
                    members: [
                        {
                            name: 'Azhar Aulia Saputra',
                            lines: ['Postdoctoral researcher, Tokyo Metropolitan University', 'Robot design expert / LLM expert', '10+ high-level SCI papers', '30+ publications']
                        },
                        {
                            name: 'Li Lianchao',
                            lines: ['Tokyo Metropolitan University', 'Master in intelligent machinery', 'Years of experience in medical products', 'Precision machinery / precision structures', 'Development industry experience']
                        }
                    ]
                },
                {
                    title: 'Big Data',
                    members: [
                        {
                            name: 'Wu Yangjie',
                            lines: ['Big data industry expert', 'AI data product decision-making / management', '8 years of big data practice experience in Japan', '50+ Japanese SMEs', 'C-level network']
                        },
                        {
                            name: 'Liao Wei',
                            lines: ['Big data technology expert', 'Master, Institute of Automation, Chinese Academy of Sciences', 'Deputy section chief, data science department', 'Rich experience in commercial and product implementation of Data*AI']
                        }
                    ]
                }
            ],
            operationsGroups: [
                {
                    title: 'Tax & Legal',
                    members: [
                        {
                            name: 'Masashi Asano',
                            lines: ['Representative tax accountant', '20 years in China-Japan tax and legal practice', 'Expert in outbound investment consulting']
                        }
                    ]
                },
                {
                    title: 'Cross-border Coordination',
                    members: [
                        {
                            name: 'Li Zengda',
                            lines: ['CEO, Mirai World Japan Co., Ltd.', 'Board member of Tokyo AI Community', '7 years of community operations experience', '8 years of cross-border project coordination experience']
                        }
                    ]
                },
                {
                    title: 'Local Channels',
                    members: [
                        {
                            name: 'Li Shihao',
                            lines: ['Project lead in innovation and entrepreneurship', 'Former Accenture strategy consultant', 'Experienced in international talent education']
                        }
                    ]
                },
                {
                    title: 'E-commerce Operations',
                    members: [
                        {
                            name: 'Bian Huixiang',
                            lines: []
                        }
                    ]
                }
            ],
            featured: [
                {
                    name: 'Toshio Fukuda',
                    title: '"Father of Micronano Robotics"',
                    lines: [
                        'PhD, The University of Tokyo; Professor at Nagoya University',
                        'Member of the Science Council of Japan; Fellow of the Engineering Academy of Japan',
                        'Elected Foreign Member of the Chinese Academy of Sciences in 2017',
                        'IEEE RAS Pioneer Award',
                        'IEEE Lifetime Achievement Award in Robotics and Automation'
                    ]
                },
                {
                    name: 'Naoyuki Kubota',
                    title: '',
                    lines: [
                        'Professor, Tokyo Metropolitan University',
                        'Doctor of Engineering, Nagoya University',
                        'Expert in computational intelligence and intelligent robotics',
                        'Holder of multiple related patents',
                        'Studied under Professor Toshio Fukuda'
                    ]
                },
                {
                    name: 'Xu Chunshan',
                    title: '',
                    lines: [
                        'Chief Development Officer, Shanghai Institute of Artificial Intelligence',
                        'First Prize of Jiangsu Science and Technology Progress Award'
                    ]
                }
            ],
            industryMembers: [
                {
                    name: 'Osamu Tanaka',
                    lines: ['Chairman, QOLTON Institute', 'Chairman, Japan Welfare Equipment Evaluation Center', 'One of the founders of rehabilitation engineering in Japan']
                },
                {
                    name: 'Yukio Igarashi',
                    lines: ['Illinois Institute of Technology', 'Master in architectural design', 'Localized management of 70+ intelligent manufacturing products on average each year', 'Java technical support and development management']
                },
                {
                    name: 'Tomoyuki Manabe',
                    lines: ['Senior logistics manager', 'Built a jointly funded logistics company with sales teams, site heads, and cargo owners', 'Participated in logistics robot introduction projects', 'Head of Otsuka warehouse']
                },
                {
                    name: 'Yoshida Kaede',
                    lines: ['Nearly 30 years of management and marketing experience in Japanese IT-related companies', 'President of the Japan chapter of CEIBS EMBA', 'Extensive market channel resources in Japan']
                },
                {
                    name: 'Yu Matsumoto',
                    lines: ['Board member of the Japan Industrial Design Association', 'Judge of the EU-Japan Design Competition', 'Committee member of the Japan Office for Shanghai EXPO']
                }
            ]
        },
        ja: {
            hero: {
                kicker: 'CORE PEOPLE',
                title: '核心人物',
                description: '顧問チーム、業界専門家、技術チーム、運営チームが連携し、未来世界の中核人物ネットワークを構成しています。'
            },
            advisorTitle: '顧問チーム',
            industryTitle: '業界専門家',
            technicalTitle: '技術チーム',
            operationsTitle: '運営チーム',
            technicalGroups: [
                {
                    title: '人工知能',
                    members: [
                        {
                            name: '胥 徳文',
                            lines: ['深層学習専門家', '東京大学教育研究科 特任研究員', 'AI産業化の豊富な実務経験', '深層学習とビッグデータの活用を推進', '医療・金融・製造業での実装を牽引']
                        },
                        {
                            name: '郭 志宇',
                            lines: ['奈良先端科学技術大学院大学', '大規模言語モデル分野の博士', 'モデル圧縮に注力', '長文推論']
                        }
                    ]
                },
                {
                    title: 'ロボティクス',
                    members: [
                        {
                            name: 'Azhar Aulia Saputra',
                            lines: ['東京都立大学 博士研究員', 'ロボット設計専門家 / LLM専門家', '10本以上の高水準SCI論文', '30本以上の論文']
                        },
                        {
                            name: '李 連超',
                            lines: ['東京都立大学', '知能機械分野 修士', '医療製品の経験多数', '精密機械 / 精密構造', '開発業界での経験']
                        }
                    ]
                },
                {
                    title: 'ビッグデータ',
                    members: [
                        {
                            name: '邬 揚捷',
                            lines: ['ビッグデータ業界専門家', 'AIデータ製品の意思決定 / 管理', '日本で8年のビッグデータ実務経験', '50社以上の日本中小企業', 'C-level ネットワーク']
                        },
                        {
                            name: '廖 威',
                            lines: ['ビッグデータ技術専門家', '中国科学院自動化研究所 修士', 'データサイエンス部門 副課長', 'Data*AIの商業応用と製品実装経験が豊富']
                        }
                    ]
                }
            ],
            operationsGroups: [
                {
                    title: '税務・法務',
                    members: [
                        {
                            name: '浅野 雅史',
                            lines: ['代表税理士', '中日税務・法務に20年従事', '海外投資コンサルティング専門家']
                        }
                    ]
                },
                {
                    title: '越境連携',
                    members: [
                        {
                            name: '李 増達',
                            lines: ['日本ミライワールド株式会社 CEO', '東京人工知能コミュニティ理事', '7年のコミュニティ運営経験', '8年の越境プロジェクト連携経験']
                        }
                    ]
                },
                {
                    title: '現地チャネル',
                    members: [
                        {
                            name: '李 時豪',
                            lines: ['イノベーション・起業分野のプロジェクト責任者', '元アクセンチュア戦略コンサルタント', '国際人材教育に精通']
                        }
                    ]
                },
                {
                    title: 'EC運営',
                    members: [
                        {
                            name: '辺 匯翔',
                            lines: []
                        }
                    ]
                }
            ],
            featured: [
                {
                    name: '福田敏男',
                    title: '「世界マイクロ・ナノロボットの父」',
                    lines: [
                        '東京大学博士 名古屋大学教授',
                        '日本学術会議会員；日本工学アカデミー会員',
                        '2017年 中国科学院外籍院士に選出',
                        'IEEEロボティクス・オートメーション学会 先駆者賞',
                        'IEEEロボティクス・オートメーション分野 終身功労賞'
                    ]
                },
                {
                    name: '久保田直行',
                    title: '',
                    lines: [
                        '東京都立大学教授',
                        '名古屋大学工学博士',
                        '計算知能および知能ロボットの専門家',
                        '関連特許多数',
                        '福田敏男教授に師事'
                    ]
                },
                {
                    name: '許 春山',
                    title: '',
                    lines: [
                        '上海人工知能研究院 首席発展責任者',
                        '江蘇省科学技術進歩一等賞'
                    ]
                }
            ],
            industryMembers: [
                {
                    name: '田中 理',
                    lines: ['QOLTON研究所 理事長', '日本福祉用具評価センター 理事長', '日本リハビリテーション工学の創始者の一人']
                },
                {
                    name: '五十嵐 幸夫',
                    lines: ['イリノイ工科大学', '建築設計分野 修士', '平均して毎年70以上のスマート製造製品を現地管理', 'Java技術支援と開発管理']
                },
                {
                    name: '真鍋智幸',
                    lines: ['上級物流マネージャー', '営業、所長、荷主との共同出資物流会社を設立', '物流ロボット導入プロジェクトに参加', '大塚倉庫責任者']
                },
                {
                    name: 'Yoshida Kaede',
                    lines: ['約30年の日本IT関連企業における経営・マーケティング経験', '中欧EMBA日本分会 会長', '日本で幅広い市場チャネル資源を保有']
                },
                {
                    name: '松本 有',
                    lines: ['日本インダストリアルデザイン協会 理事', 'EU-Japan Design Competition 審査員', '上海万博日本事務所 委員']
                }
            ]
        }
    }
};
